module.exports = __webpack_public_path__ + "img/icb-empty-Inte-e@2x.7a441f93.png";